import { Check, AppWindow, Headset } from "lucide-react";

const rows = [
  { app: "Plataforma para equipe própria", service: "Operação assistida pelo nosso time" },
  { app: "Mais autonomia operacional", service: "Acompanhamento estratégico contínuo" },
  { app: "Treinamento incluso", service: "Inteligência aplicada à campanha" },
  { app: "Operação interna da equipe", service: "Squad especializado dedicado" },
  { app: "Estrutura escalável", service: "Gestão operacional completa" },
  { app: "Controle total da campanha", service: "Monitoramento contínuo 24/7" },
];

export function ComparativoSection() {
  return (
    <section id="comparativo" className="py-24 bg-muted/30 relative">
      <div className="mx-auto max-w-6xl px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/10 text-accent text-xs font-semibold uppercase tracking-wider">
            Comparativo
          </div>
          <h2 className="mt-4 text-4xl sm:text-5xl font-bold text-foreground">
            Qual estrutura{" "}
            <span className="bg-gradient-primary bg-clip-text text-transparent">faz mais sentido para sua campanha?</span>
          </h2>
        </div>

        <div className="mt-12 rounded-3xl border border-border bg-card shadow-card overflow-hidden">
          <div className="grid grid-cols-1 md:grid-cols-2">
            <div className="p-6 lg:p-8 border-b md:border-b-0 md:border-r border-border">
              <div className="flex items-center gap-3 mb-6">
                <div className="h-11 w-11 rounded-xl bg-gradient-primary flex items-center justify-center shadow-soft">
                  <AppWindow className="h-5 w-5 text-primary-foreground" />
                </div>
                <div>
                  <div className="text-[11px] uppercase tracking-wider font-bold text-accent">Plataforma</div>
                  <div className="text-xl font-bold text-foreground">Vox App</div>
                </div>
              </div>
              <ul className="space-y-3">
                {rows.map((r) => (
                  <li key={r.app} className="flex items-start gap-3 text-sm">
                    <span className="mt-0.5 h-5 w-5 rounded-full bg-success/15 flex items-center justify-center shrink-0">
                      <Check className="h-3 w-3 text-success" strokeWidth={3} />
                    </span>
                    <span className="text-foreground">{r.app}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="p-6 lg:p-8 bg-gradient-cta text-primary-foreground relative overflow-hidden">
              <div className="absolute -top-24 -right-24 h-64 w-64 rounded-full bg-accent/30 blur-3xl pointer-events-none" />
              <div className="relative">
                <div className="flex items-center gap-3 mb-6">
                  <div className="h-11 w-11 rounded-xl bg-white/15 flex items-center justify-center">
                    <Headset className="h-5 w-5 text-highlight" />
                  </div>
                  <div>
                    <div className="text-[11px] uppercase tracking-wider font-bold text-highlight">Operação</div>
                    <div className="text-xl font-bold">Vox Service</div>
                  </div>
                </div>
                <ul className="space-y-3">
                  {rows.map((r) => (
                    <li key={r.service} className="flex items-start gap-3 text-sm">
                      <span className="mt-0.5 h-5 w-5 rounded-full bg-highlight/25 flex items-center justify-center shrink-0">
                        <Check className="h-3 w-3 text-highlight" strokeWidth={3} />
                      </span>
                      <span className="text-primary-foreground/95">{r.service}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
